module.exports = "/images/vendor/desiigner-svg/svg/world-delivery.svg?b90ce14dff093692393b4d38ee18ed9b";